import { render, staticRenderFns } from "./Trusteeship.vue?vue&type=template&id=73bf05fa&scoped=true&"
import script from "./Trusteeship.vue?vue&type=script&lang=js&"
export * from "./Trusteeship.vue?vue&type=script&lang=js&"
import style0 from "./Trusteeship.vue?vue&type=style&index=0&id=73bf05fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bf05fa",
  null
  
)

export default component.exports